import { AssetTypeCode } from 'types/models/asset-type';
import { UnitOfTime } from 'types/models/time';

export const integratedAssetTypes = [AssetTypeCode.SECURITY_CAMERA];
export const CIBO_MATTER_PRECISION = 0;
export const CIBO_AREA_PRECISION = 0;
export const CIBO_LOCATION_ADJUSTMENT_PERIOD_IN_HOURS = 48;

export enum CiboLocationRadius {
  KM_0_5 = 0.5,
  KM_1 = 1,
  KM_3 = 3,
  KM_5 = 5
}

export const CIBO_LOCATION_RADIUS_TO_SUGGESTED_ZOOM_LEVEL: Record<CiboLocationRadius, number> = {
  [CiboLocationRadius.KM_0_5]: 15,
  [CiboLocationRadius.KM_1]: 14,
  [CiboLocationRadius.KM_3]: 12,
  [CiboLocationRadius.KM_5]: 11
};

export const CIBO_LOCATION_DEFAULT_RADIUS_KM = CiboLocationRadius.KM_0_5;

// To obtain 6 hours of weather data including the latest hour, we look back 5 hours
export const WEATHER_DASHBOARD_LOOKBACK_HOURS = 5;
export const WEATHER_DASHBOARD_TIME_UNIT: UnitOfTime = 'hour';
/**
 * A physically connected weather station only sends battery data to MFB every two days.
 * So, to obtain at least two data points to draw a trend line, we look back two days. */
export const WEATHER_DASHBOARD_BATTERY_LOOKBACK_DAYS = 2;
